declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';


import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SaveProviderServiceChargeRequest, SaveSingleEmbryoGradeInfoRequest, ActorImageController, IvfEmbryoGradingByCycleController, IvfEmbryoGradingByCycleRequest, SaveEmbryoStoreInfoRequest } from '../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../models/master/mastermodel';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgbActorDocsModal } from '../../profile/modals/actordocs/actordocs.modal';

@Component({
  selector: 'ngbeditgradingfet',
    templateUrl: './editgradingfet.modal.html',
    styleUrls: ['./editgradingfet.modal.scss']
})

export class NgbEditGradingFetModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;

    @Input() IsShowDetail: boolean = false;
    @Input() EmbryoGradeCode: number;
    @Input() model: string;
    @Input() Select: boolean = false;
    @Input() DocumentUrl: string;
    @Input() CurrentSaveSingleEmbryoGradeInfoRequest: SaveSingleEmbryoGradeInfoRequest;
    @Input() ServiceCode: number;
    @Input() Wellno: number;
    @Input() ImageCodenew: number;
    @Input() Technique: string;
    @Input() oqa: string;
    @Input() Day: number;
    public Date: Date;
    public DOC: number;
    public Embryocount: number;
    @Input() PatientName: string;
    @Input() Cyclenumber: number;
    @Input() ActorCode: number;
    public 
  searchTitle: string;
  public ApiResData: ApiResponseModel;
    ValueChangeActorImageController: ActorImageController;
  public isRequesting: boolean = false;
  public ShowService: boolean = true;
  public discard: boolean = true;
  public freeze: boolean = false;
    public Transfer: boolean = false;
    public Grade1: string;
    public Grade2: string;
  //public IsSelected: boolean;
  CurrentSaveProviderServiceChargeRequest: SaveProviderServiceChargeRequest;
    CurrentDeleteProviderServiceChargeRequest: SaveProviderServiceChargeRequest;
    CurrentSaveEmbryoStoreInfoRequest: SaveEmbryoStoreInfoRequest;
    CurrentIvfEmbryoGradingByCycleController: IvfEmbryoGradingByCycleController[];
    CurrentIvfEmbryoGradingByCycleRequest: IvfEmbryoGradingByCycleRequest;

    LoadGradingData() {
        //alert("ScansData")
        this.CurrentIvfEmbryoGradingByCycleRequest = new IvfEmbryoGradingByCycleRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentIvfEmbryoGradingByCycleRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIvfEmbryoGradingByCycleController();
    }
    //AddRowMaturity() {
    //  if (this.CurrentOocyteMaturityByCycleController == null) {
    //    this.CurrentOocyteMaturityByCycleController = new Array<OocyteMaturityByCycleController>();
    //  }
    //  if (this.CurrentOocyteMaturityByCycleController != null) {

    //    var row = new OocyteMaturityByCycleController();

    //    row.MaturityLevel = "";
    //    row.OccCount = 0;
    //    row.DenudedCount = 0;
    //    this.CurrentOocyteMaturityByCycleController.push(row);
    //    this.tosterservice.ToasterSuccessAlertParam('New Row Added Successfully.....!');

    //  }

    //}
    //checkDoc(val: number): boolean {
    //    return val.toString() == this.DOC;
    //}
    GetIvfEmbryoGradingByCycleController() {
        //  alert(this.DOC);
        this.CurrentIvfEmbryoGradingByCycleRequest.ConditionalOperator = 10;
        this.CurrentIvfEmbryoGradingByCycleRequest.CycleCode = this.Cyclenumber;
        this.CurrentIvfEmbryoGradingByCycleRequest.DOC ="" ;


        this.actorservice.GetIvfEmbryoGradingByCycleController(this.CurrentIvfEmbryoGradingByCycleRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    this.CurrentIvfEmbryoGradingByCycleController = this.ApiResData.Result;
                    //   var _CurrentIvfEmbryoGradingByCycleController: IvfEmbryoGradingByCycleController[]  = this.ApiResData.Result;
                    //   alert('grades count: ' + _CurrentIvfEmbryoGradingByCycleController.length.toString());
                    //this.CurrentIvfEmbryoGradingByCycleController = _CurrentIvfEmbryoGradingByCycleController.filter(
                    //    function (v, i, d) {
                    //    //if (v.DOC.toString() == this.DOC)
                    //    //    alert('Mmmmmm');
                    //        return this.checkDoc(v.DOC);//.toString() == this.DOC
                    //});
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService,
      private tosterservice: NGXToastrService, private modalService: NgbModal) { }
  ngOnInit() {
    this.CurrentSaveProviderServiceChargeRequest = new SaveProviderServiceChargeRequest();
    //this.CurrentSaveProviderServiceChargeRequest.ConditionalOperator = 20;
      this.CurrentSaveProviderServiceChargeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentSaveEmbryoStoreInfoRequest = new SaveEmbryoStoreInfoRequest();
      this.CurrentSaveEmbryoStoreInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentDeleteProviderServiceChargeRequest = new SaveProviderServiceChargeRequest();
    this.CurrentDeleteProviderServiceChargeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.ShowService = false;
      this.ValueChangeActorImageController = new ActorImageController();
      this.LoadGradingData();
    //this.LoadRegistries();
    

  }

  
  
  //GetBranchMap() {
  //  this.StartRefreshing();
  //  this.BranchMapRequest.ServiceCode = this.ServiceCode;

  //  this.actorservice.GetServiceBranchMapByServiceCodeController(this.BranchMapRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        this.BranchMapData = this.ApiResData.Result;
  //        //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
  //        //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
  //        //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
  //        this.stopRefreshing();

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },


  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();



  //        }
  //        else {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();
  //        }
  //      }


  //    );


  //}
    
    
    openDocContent() {
       
            let options: NgbModalOptions = {
                size: 'lg'
            };
            const modalRef = this.modalService.open(NgbActorDocsModal, options)//.result(result => { this.GetActorProfileController();});
        modalRef.componentInstance.ActorDocCode = this.ImageCodenew;
        modalRef.componentInstance.ActorCode = this.ActorCode;
        modalRef.componentInstance.DocType= "Embryo Grading";
        modalRef.componentInstance.DocTitle= "Embryo Grading";
            //modalRef.componentInstance.CanEdit = 1;
            //modalRef.componentInstance.CanShow = 1;
        modalRef.result.then(x => {
          //  alert('Received: ' + x);
            var data: ApiResponseModel = x;
            this.ImageCodenew = data.Result;
        //    this.GetActorIdentitiesController()
        })
       
       
    }
    


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
    
 
  discarddata() {
    this.freeze = false;
    this.Transfer = false;
    this.discard = true;
  }
  Freezedata() {
    this.discard = false;
    this.Transfer = false;
    this.freeze = true;
  }
  Transferdata() {
    this.freeze = false;
    this.discard = false;
    this.Transfer = true;
    }
    EditStore2(l: IvfEmbryoGradingByCycleController) {
        this.Select = true;
        this.model = "";
        //this.CurrentSaveEmbryoStoreInfoRequest.Count = l.EmbryoCount;
        this.CurrentSaveEmbryoStoreInfoRequest.CellStage = l.CellStage;
        this.CurrentSaveEmbryoStoreInfoRequest.DOC = l.DOC;
        this.CurrentSaveEmbryoStoreInfoRequest.FetDropletGradingCode = 0;
        this.CurrentSaveEmbryoStoreInfoRequest.Grade = l.Grade1 + l.Grade2;
        
        this.Grade1 = l.Grade1;
        this.Grade2 = l.Grade2;
        this.Date = l.LastModifiedTime;
        this.DOC = l.DOC;
        this.Embryocount = l.EmbryoCount;
        
    }
    onSubmit() {

        this.StartRefreshing();
        //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);
        this.CurrentSaveEmbryoStoreInfoRequest.ConditionalOperator = 10;

        this.CurrentSaveEmbryoStoreInfoRequest.ActorCode = this.ActorCode;// this.ValueChangeActorImageController.ActorImageCode;
        this.CurrentSaveEmbryoStoreInfoRequest.CreatedUser = AppData.Instance().UserLoginDetails.EmpFacilityCode;
        this.CurrentSaveEmbryoStoreInfoRequest.CreatedUserName = AppData.Instance().UserLoginDetails.UserName;
        this.CurrentSaveEmbryoStoreInfoRequest.CycleCode = this.Cyclenumber;
        this.CurrentSaveEmbryoStoreInfoRequest.Date = new Date();

        this.actorservice.SaveEmbryoStoreInfo(this.CurrentSaveEmbryoStoreInfoRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        this.ShowService = false;
                        //alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

                        this.activeModal.close();

                        this.stopRefreshing();
                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");
                        this.activeModal.close();

                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        this.activeModal.close();


                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                        this.activeModal.close();
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.activeModal.close();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.activeModal.close();
                        this.stopRefreshing();
                    }
                }
            );

    }

}
